import React from 'react';
import PropTypes from 'prop-types';

export const Row = props => <div className={['form-register_row', props.classes && props.classes].join(' ')} ref={props.setRef}>{props.children}</div>;

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export const Col = props => <div className="form-register_col">{props.children}</div>;

Col.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};



// WEBPACK FOOTER //
// ./src/Components/Register/Scaffold.jsx